import React from 'react';

const ACCENT = '#C9A84C';

function formatTime(t) {
  const [h, m] = t.split(':').map(Number);
  return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${h >= 12 ? 'PM' : 'AM'}`;
}

export default function ReviewStep({ service, slot, clientInfo, addDeepFacial, deepFacialService, onSubmit, onBack, loading, error }) {
  const displayDate = new Date(slot.date + 'T00:00:00').toLocaleDateString('en-US', {
    weekday: 'long', month: 'long', day: 'numeric', year: 'numeric'
  });

  const isMobile = service.is_mobile;
  const isSunday = new Date(slot.date + 'T00:00:00').getDay() === 0;
  const depositRequired = isSunday || isMobile;
  const depositAmount = depositRequired ? (parseFloat(slot.price) * 0.5).toFixed(0) : null;

  const rows = [
    { label: 'Service', value: service.name },
    { label: 'Duration', value: `${service.duration_minutes} min` },
    { label: 'Date', value: displayDate },
    { label: 'Time', value: formatTime(slot.start_time) },
    { label: 'Price', value: `$${parseFloat(slot.price).toFixed(0)}${slot.is_after_hours ? ' (after hours)' : ''}` },
    { label: 'Name', value: clientInfo.name },
    { label: 'Phone', value: clientInfo.phone },
    clientInfo.email ? { label: 'Email', value: clientInfo.email } : null,
    clientInfo.notes ? { label: 'Notes', value: clientInfo.notes } : null,
    isMobile && clientInfo.mobile_location ? { label: 'Location', value: clientInfo.mobile_location } : null,
    isMobile && clientInfo.mobile_event_type ? { label: 'Event', value: clientInfo.mobile_event_type } : null,
    isMobile && clientInfo.mobile_people_count ? { label: 'People', value: clientInfo.mobile_people_count } : null,
  ].filter(Boolean);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '28px' }}>
        <button onClick={onBack} className="btn btn-ghost" style={{ padding: '8px 12px' }}>← Back</button>
        <div>
          <h2 style={{ fontSize: '18px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Review & Submit</h2>
          <p style={{ color: '#888', fontSize: '13px' }}>Confirm your request before submitting</p>
        </div>
      </div>

      {/* Summary card */}
      <div style={{
        background: 'rgba(201,168,76,0.03)', border: '1px solid rgba(201,168,76,0.3)', borderRadius: '8px',
        padding: '22px', marginBottom: '16px',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
          <div>
            <div style={{ fontWeight: 900, fontSize: '19px', letterSpacing: '0.01em', marginBottom: '4px' }}>{service.name}</div>
            {slot.is_after_hours && (
              <span className="badge badge-after-hours">After Hours</span>
            )}
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ color: ACCENT, fontWeight: 900, fontSize: '30px', lineHeight: 1, letterSpacing: '-0.02em' }}>
              ${parseFloat(slot.price).toFixed(0)}
            </div>
            {depositRequired && (
              <div style={{ color: '#888', fontSize: '12px', marginTop: '3px' }}>
                Deposit: <strong style={{ color: ACCENT }}>${depositAmount}</strong>
              </div>
            )}
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {rows.map(({ label, value }) => (
            <div key={label} style={{
              display: 'flex', gap: '12px', alignItems: 'flex-start',
              borderBottom: '1px solid rgba(255,255,255,0.04)', paddingBottom: '10px',
            }}>
              <span style={{ color: '#555', fontSize: '12px', width: '80px', flexShrink: 0, textTransform: 'uppercase', letterSpacing: '0.06em', paddingTop: '1px' }}>
                {label}
              </span>
              <span style={{ fontWeight: 600, fontSize: '14px', flex: 1 }}>{value}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Deep Facial add-on */}
      {addDeepFacial && deepFacialService && (
        <div style={{
          background: 'rgba(201,168,76,0.05)', border: '1px solid rgba(201,168,76,0.3)', borderRadius: '8px',
          padding: '14px 18px', marginBottom: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        }}>
          <div>
            <div style={{ fontWeight: 700, fontSize: '14px', color: ACCENT }}>✨ Deep Facial Add-On</div>
            <div style={{ color: '#888', fontSize: '12px', marginTop: '2px' }}>20 min · Booked separately</div>
          </div>
          <div style={{ color: ACCENT, fontWeight: 900, fontSize: '18px' }}>+$60</div>
        </div>
      )}

      {/* Card on file */}
      <div style={{
        background: '#141414', border: '1px solid #222', borderRadius: '6px',
        padding: '14px 16px', marginBottom: '12px', fontSize: '13px', color: '#888', lineHeight: 1.7,
      }}>
        <strong style={{ color: '#ccc' }}>No charge now.</strong> Christian confirms your booking first.
        {depositRequired && (
          <span> A <strong style={{ color: ACCENT }}>${depositAmount} deposit</strong> ({isMobile ? 'mobile service' : 'Sunday booking'}) is collected at confirmation.</span>
        )}
      </div>

      {/* Cancellation */}
      <div style={{
        background: '#0d0d0d', border: '1px solid #1a1a1a', borderRadius: '6px',
        padding: '12px 16px', marginBottom: '22px', fontSize: '12px', color: '#555', lineHeight: 1.8,
      }}>
        <strong style={{ color: '#888', textTransform: 'uppercase', letterSpacing: '0.06em', fontSize: '11px' }}>Cancellation:</strong>{' '}
        3+ hours before → free. Under 3 hours → 50%. No-show → 100%.
      </div>

      {error && (
        <div style={{
          color: '#ef4444', background: 'rgba(239,68,68,0.08)',
          border: '1px solid rgba(239,68,68,0.25)', padding: '12px 16px', borderRadius: '6px',
          fontSize: '14px', marginBottom: '16px',
        }}>
          {error}
        </div>
      )}

      <button
        type="button"
        onClick={onSubmit}
        className="btn btn-primary w-full"
        disabled={loading}
        style={{ padding: '18px', fontSize: '14px', width: '100%' }}
      >
        {loading ? 'Submitting...' : 'Submit Request'}
      </button>

      <p style={{ textAlign: 'center', color: '#444', fontSize: '12px', marginTop: '14px', letterSpacing: '0.04em' }}>
        All bookings are request-based. Christian will confirm shortly.
      </p>
    </div>
  );
}
